import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useMemo,
  useState,
} from 'react';
import createSafeContext from '@paradigm/utils/createSafeContext';

interface View {
  readonly isOpen: boolean;
}

interface State {
  readonly isOpen: boolean;
}

interface Actions {
  readonly open: () => void;
  readonly close: () => void;
}

const INITIAL_STATE: State = {
  isOpen: false,
};

const [useViewCtx, ViewCtxProvider] = createSafeContext<View>(
  'PositionFiltersModalView',
);

const [useActionsCtx, ActionsCtxProvider] = createSafeContext<Actions>(
  'PositionFiltersModalActions',
);

export const usePositionFiltersModalView = useViewCtx;
export const usePositionFiltersModalActions = useActionsCtx;

export default function PositionFiltersModalProvider({
  children,
}: PropsWithChildren) {
  const [state, setState] = useState<State>(INITIAL_STATE);

  const actions = useMemo(() => createActions(setState), []);
  const view = useMemo(() => createView(state), [state]);

  return (
    <ViewCtxProvider value={view}>
      <ActionsCtxProvider value={actions}>{children}</ActionsCtxProvider>
    </ViewCtxProvider>
  );
}

function createView(state: State): View {
  return {
    isOpen: state.isOpen,
  };
}

function createActions(setState: Dispatch<SetStateAction<State>>): Actions {
  return {
    open: () => {
      setState({ isOpen: true });
    },
    close: () => {
      setState({ isOpen: false });
    },
  };
}
